import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/header";
import { useAuth } from "../hooks/AuthContext";
import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import Menu from "../components/Menu";
import Chat from "../components/Chat";

const { Sider } = Layout;

const RouteTecnicos = ({ hiddenSiderbad, hiddenButtonBack }) => {
  const user = useAuth();

  useEffect(() => {
    let type = "";
    if (user.user) {
      type = user.user.type;
    }

    if (!type) {
      window.location.assign("/login");
    } else {
      if (type != "tecnico") {
        if (type == "tecnico") {
          window.location.assign("/cliente/home");
        } else {
          if (type == "atendente") {
            window.location.assign("/atendente/home");
          } else {
            if (type == "associado") {
              window.location.assign("/associado/home");
            } else {
              window.location.assign("/admin/home");
            }
          }
        }
      }
    }
  }, []);

  let type = "";
  if (user.user) {
    type = user.user.type;
  }

  return type == "tecnico" ? (
    <Layout style={{ minHeight: "100vh" }}>
      <Header sidebar={!hiddenButtonBack} />
      <Layout>
        {!hiddenSiderbad && (
          <Sider
            style={{
              background: "#008037",
              height: "100vh",
              position: "sticky",
              top: 0,
              left: 0,
              zIndex: 1000,
            }}
            width={230}
            trigger={null}
            collapsedWidth={0}
            breakpoint={"xl"}
          >
            <Menu />
          </Sider>
        )}
        <Content className="content">
          <Outlet />
          <Chat />
        </Content>
      </Layout>{" "}
    </Layout>
  ) : (
    <></>
  );
};
export default RouteTecnicos;
